<template>
  <div class="row mb-3 mt-3 pt-4 pb-4 border-top border-bottom">
    <div class="col text-center text-secondary">
      <i class="fa fa-circle fa-2x p-2"></i>
      <i class="fa fa-circle fa-2x p-2"></i>
      <i class="fa fa-circle fa-2x p-2"></i>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "Separator",
});
</script>

<style scoped></style>
